import * as R from 'ramda';
export function isObject(obj) {
    var typename = typeof obj;
    return (obj &&
        typename !== 'string' &&
        typename !== 'number' &&
        typename !== 'boolean' &&
        typename !== 'function' &&
        !Array.isArray(obj));
}
export function isEmpty(i) {
    if (typeof i === 'string')
        return !i.trim();
    return R.isEmpty(i) || R.isNil(i) || Number.isNaN(i);
}
export function isNumber(i) {
    return typeof i === 'number';
}
export function isFixedPosition(pos) {
    return typeof pos === 'object';
}
export function px(p) {
    return p + "px";
}
export function pxWithAuto(p) {
    return p === 'auto' ? 'auto' : p + "px";
}
export function percent(pc) {
    return pc + "%";
}
export function setUnit(unit, value) {
    if (typeof value === 'string' || !value) {
        return value;
    }
    if (unit === 'percent') {
        return value.toFixed(2) + "%";
    }
    if (unit === 'px' || !unit) {
        return value.toFixed(0) + "px";
    }
}
export function getComponentId(key) {
    return "__impage-component-wrapper-" + key;
}
export function getHotAreaId(key) {
    return "__impage-hotarea-wrapper-" + key;
}
var id = -1;
/** 生成id, 递增 */
export var generateId = function () {
    return ++id;
};
/** 获取最大id */
export var getMaxId = function () { return id; };
/** 设置最大id */
export var setMaxId = function (max) {
    if (max > id) {
        id = max;
    }
};
/** 重置最大id */
export var resetMaxId = function () {
    id = -1;
};
var MAX_MEMO_ITEMS = 20;
export function withMemo(fn) {
    var memo = [];
    Object.defineProperty(fn, '__memo', {
        get: function () {
            return memo;
        },
    });
    return function (arg) {
        var memo = fn.__memo;
        if (memo) {
            var item = memo.find(function (i) { return i.arg === arg; });
            if (item) {
                return item.result;
            }
        }
        var result = fn(arg);
        memo.push({ arg: arg, result: result });
        setTimeout(function () {
            if (memo.length > MAX_MEMO_ITEMS) {
                memo.splice(0, memo.length - MAX_MEMO_ITEMS);
            }
        }, 10);
        return result;
    };
}
//# sourceMappingURL=common.js.map